import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SITE_URL = 'https://theguyinsa.co.za';

export default function SEOHead({ title, description, image, schema, children }) {
  const location = useLocation();
  const [dynamicMeta, setDynamicMeta] = useState(null);

  // Fetch dynamic meta from backend if not provided via props
  useEffect(() => {
    if (title) return; // Props take precedence
    const path = location.pathname;
    axios.get(`${API_URL}/api/seo/meta${path}`)
      .then(res => setDynamicMeta(res.data))
      .catch(() => {});
  }, [location.pathname, title]);

  const meta = {
    title: title || dynamicMeta?.title || 'The Guy in SA — Cross-Border Procurement & Logistics',
    description: description || dynamicMeta?.description || 'Cross-border procurement and logistics from Johannesburg to Maputo.',
    canonical: dynamicMeta?.canonical || `${SITE_URL}${location.pathname}`,
    image: image || dynamicMeta?.og_image || `${SITE_URL}/og-image.png`,
  };

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={meta.canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={meta.canonical} />
      <meta property="og:image" content={meta.image} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="The Guy in SA" />
      <meta property="og:locale" content="en_ZA" />
      <meta property="og:locale:alternate" content="pt_MZ" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={meta.image} />

      {/* hreflang */}
      <link rel="alternate" hrefLang="en" href={meta.canonical} />
      <link rel="alternate" hrefLang="pt" href={`${meta.canonical}${meta.canonical.includes('?') ? '&' : '?'}lang=pt`} />
      <link rel="alternate" hrefLang="x-default" href={meta.canonical} />

      {/* Structured Data */}
      {schema && Array.isArray(schema) ? (
        schema.map((s, i) => (
          <script key={`schema-${i}`} type="application/ld+json">{JSON.stringify(s)}</script>
        ))
      ) : schema ? (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      ) : null}

      {children}
    </Helmet>
  );
}
